import { useState } from "react";
import apiClient from "@/api/apiClient";
import { toast } from "react-toastify";

export const useSubmitForm = () => {
  const [loading, setLoading] = useState(false);

  const submitRequest = async (url, payload, onSuccess) => {
    setLoading(true);

    try {
      const response = await apiClient.post(url, payload);

      if (response.status === 200 || response.status === 201) {
        toast.success("Submitted successfully");
        if (onSuccess) onSuccess(response.data);
      }
      return response.data;
    } catch (error) {
      // Log the full technical error in developer console for debugging
      console.error("Backend Error Intercepted:", error);

      // FORCE FRONTEND-ONLY ERROR MESSAGE
      // Never read error.response.data.message to prevent backend DTO errors in UI
      toast.error("Please check your input details and try again.");
    } finally {
      setLoading(false);
    }
  };

  return { submitRequest, loading };
};
